export const formatFeetAndInches = (decimalFeet: number) => {
	const feet = Math.floor(decimalFeet);
	const inches = parseFloat(((decimalFeet - feet) * 12).toFixed(1));

	if (inches === 0) {
		return `${feet} ft`;
	} else if (feet === 0) {
		return `${inches} in`;
	} else {
		return `${feet} ft ${inches} in`;
	}
};